import Logger from 'services/logger';

export const checkServerAvailability = async (url, MAX_RETRIES, attempt = 1) => {
    try {
        const response = await fetch(url, {
            method: 'POST',
            cache: 'no-cache'
        });

        if (response.ok || response.status === 405) { // 405 = Method Not Allowed (pero servidor responde)
            return true;
        }

        throw new Error(`Server responded with status ${response.status}`);
    } catch (error) {
        Logger.warn('[checkServerAvailability] intento fallido', {
            attempt,
            url,
            error: error?.message,
        });

        if (attempt < MAX_RETRIES) {
            await new Promise(resolve => setTimeout(resolve, 1000));
            return checkServerAvailability(url, MAX_RETRIES, attempt + 1);
        }

        return false;
    }
}
